export default __webpack_public_path__ + "static/media/coin.fa706b2a.svg";